import { useCreation } from 'ahooks'
import { nanoid } from 'nanoid'

export type TraceRequestActions = {
  getPageId: () => string
  getSessionId: () => string
}

export const useTraceRequest = (): TraceRequestActions => {
  // Stable identity is a requirement (clients and effects key on this
  // object), so useCreation, not useMemo, which React may discard. The ids
  // are minted inside so nanoid runs once, not on every render.
  return useCreation(() => {
    const sessionId = nanoid(12)
    const pageId = nanoid(8)
    return {
      getPageId: () => pageId,
      getSessionId: () => sessionId,
    }
  }, [])
}
